export default {
  companyListInfo: {},
  companyList: [],
  companyTree: {},
  companyInfo: {},
  virtualCompanyList: [],
  virtualCompanyInfo: {},
  memberList: [],
  fieldList: [],
}
